module.exports = __webpack_public_path__ + "static/media/three_collecting_waves@2x.5a3fbd61.png";